import React from 'react';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import TimeOutputLayoutItemForm from 'components/organismos/master/attend/TimeOutputLayout/TimeOutputLayoutItemForm';

const TimeOutputItemPage: React.FC = () => {

  return (
    <SidebarTemplate>
      <TimeOutputLayoutItemForm />
    </SidebarTemplate>
  );
};

export default TimeOutputItemPage;
